import {
  createSlice,
  PayloadAction,
  // createAsyncThunk,
  // createDraftSafeSelector,
} from "@reduxjs/toolkit";
import store, { RootState } from "store";

interface IInitialState {
  visible: boolean;
  formData: any;
  milestone: any;
  formChanged: boolean;
}

const initialState: IInitialState = {
  visible: false,
  formData: {},
  milestone: null,
  formChanged: false
};

export const formSlice = createSlice({
  name: "form",
  initialState: initialState,
  reducers: {
    setVisible: (state, action: PayloadAction<any>) => {
      state.visible = action.payload;
      if(action.payload === false) {
        state.formData = {};
      }
    },
    setformModal: (state, action: PayloadAction<any>) => {
      state.formData = action.payload;
    },
    setMilestone(state, { payload }) {
      state.milestone = payload;
    },
    setFormChanged(state, { payload }) {
      state.formChanged = payload;
    },
  },
});

export const mapformModalVisible = (state: RootState) => state.form.visible;
export const mapFormModalData = (state: RootState) => state.form.formData;
export const { setformModal, setVisible, setMilestone, setFormChanged } =
  formSlice.actions;

export const setFormModalData = (data: any) => {
  const dispatch = store.dispatch;
  dispatch(setformModal(data))
}

export const setFormModalVisible = (visible: boolean) => {
  const dispatch = store.dispatch;
  dispatch(setVisible(visible))
};

export default formSlice.reducer;
